import {
  PeopleIcon,
  AssignmentTurnedInIcon,
  ScheduleIcon,
  ReportProblemIcon,
  LockIcon,
  NotificationsIcon,
} from 'components/uiIcons';
import {
  SpaceLink,
  DashboardLink,
  SpaceInspectionLink,
  SpaceInspectionsLink,
  SpaceBillingLink,
} from 'utils/link';
import { clearStoredSpaceId } from 'contexts/space';
import theme from 'theme';

export const NOTIFICATION_KINDS = [
  'space.invited',
  'space.role_changed',
  'space.ownership_transferred',
  'inspection.assigned',
  'inspection.due_soon',
  'inspection.overdue',
  'inspection.completed',
  'inspection.canceled',
  'inspection.limit_reached',
];

export const NOTIFICATION_KIND_GROUPS = {
  space: ['space.invited', 'space.role_changed', 'space.ownership_transferred'],
  inspection: [
    'inspection.assigned',
    'inspection.due_soon',
    'inspection.overdue',
    'inspection.completed',
    'inspection.canceled',
    'inspection.limit_reached',
  ],
};

export const parseNotificationPayload = (notification) => {
  if (!notification?.payload) return {};
  try {
    return JSON.parse(notification.payload);
  } catch {
    return {};
  }
};

export const notificationIcon = (kind) => {
  switch (kind) {
    case 'space.invited':
    case 'space.role_changed':
    case 'space.ownership_transferred':
      return PeopleIcon;
    case 'inspection.assigned':
    case 'inspection.completed':
    case 'inspection.canceled':
      return AssignmentTurnedInIcon;
    case 'inspection.due_soon':
      return ScheduleIcon;
    case 'inspection.overdue':
      return ReportProblemIcon;
    case 'inspection.limit_reached':
      return LockIcon;
    default:
      return NotificationsIcon;
  }
};

export const notificationColor = (kind) => {
  const palette = theme.palette.notification;
  switch (kind) {
    case 'space.invited':
    case 'space.role_changed':
    case 'space.ownership_transferred':
      return palette.space;
    case 'inspection.due_soon':
      return palette.dueSoon;
    case 'inspection.overdue':
      return palette.overdue;
    case 'inspection.limit_reached':
      return palette.limitReached;
    default:
      return palette.inspection;
  }
};

export const notificationRoute = (notification) => {
  const notifiableId = notification.notifiable?.id;
  const spaceId =
    notification.space?.id ||
    (notification.notifiable?.__typename === 'Space' ||
    notification.notifiable?.__typename === 'SpaceType'
      ? notifiableId
      : null);

  switch (notification.kind) {
    case 'space.role_changed':
    case 'space.ownership_transferred':
      return spaceId ? SpaceLink(spaceId) : null;
    case 'space.invited':
      clearStoredSpaceId();
      window.location.reload();
      return null;
    case 'inspection.assigned':
    case 'inspection.completed':
    case 'inspection.canceled':
      return spaceId && notifiableId ? SpaceInspectionLink(spaceId, notifiableId) : null;
    case 'inspection.due_soon':
      return spaceId ? SpaceInspectionsLink(spaceId, 'incoming') : null;
    case 'inspection.overdue':
      return spaceId ? SpaceInspectionsLink(spaceId, 'overdue') : null;
    case 'inspection.limit_reached':
      return spaceId ? SpaceBillingLink(spaceId) : null;
    default:
      return null;
  }
};
